














































































import Vue from 'vue';
// import exhibitorM, { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import companyM, { Company } from '@/modules/exhibitor/company';

import {
  // exhibitor,
  // Exhibitor,
  exhibitorCompany,
  ExhibitorCompanyListItem,
  calender,
} from 'mostra';

export type DataType = {
  exhibitorCompanyList: ExhibitorCompanyListItem[];
  currentPage: number;
  perPage: number;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-admin-exhibitor-index',
  data(): DataType {
    return {
      exhibitorCompanyList: [],
      currentPage: 1,
      perPage: 500,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.exhibitorCompanyList = await exhibitorCompany.loadExhibitorCompanyList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      this.exhibitorCompanyList = await exhibitorCompany.loadExhibitorCompanyList(this.perPage, 1);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
  methods: {
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.exhibitorCompanyList = await exhibitorCompany.loadExhibitorCompanyList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllExhibitorCompanies() {
      this.total = await exhibitorCompany.countAllExhibitorCompanies();
    },
  },
});
